import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { logger } from "redux-logger";
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import addChildSlice from "./addChild";
import authorizationSlice from "./authorization";
import langSlice from "./lang";
import timeSlice from "./timeSlice";
import viewsData from "./viewsData";

const persistConfig = {
  key: "Amuse",
  version: 1,
  storage,
};
const reducer = {
  auth: authorizationSlice,
  lang: langSlice,
  childData: addChildSlice,
  subscriptionRequest: timeSlice,
  viewsData,
};
const rootReducer = combineReducers(reducer);
const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(logger),
  devTools: process.env.NODE_ENV !== "production",
});

export default store;
